export const environment = {
  firebase: {
    apiKey: "AIzaSyBtvHyPefDjhWiWvcz2mJEL9EXZ7YqEb7A",
  authDomain: "woundapp-261e6.firebaseapp.com",
  projectId: "woundapp-261e6",
  storageBucket: "woundapp-261e6.firebasestorage.app",
  messagingSenderId: "43052843352",
  appId: "1:43052843352:web:ee55589f67c31750eca52d",
  measurementId: "G-HJZG1QZ6FW"
  },
  apiBase: 'https://us-central1-woundapp-261e6.cloudfunctions.net/apiV2',
  production: true
};
